export enum APK_FILE_UPLOAD_STATUS {
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  NOT_PROCESSED = 'NOT_PROCESSED',
}
